/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.label.optional\":[\"Valfritt\"],\"checkbox-group.validation.required\":[\"Minst ett val krävs.\"]}");
//# sourceMappingURL=messages.mjs.map